import React from 'react';
import { Link } from 'react-router-dom'


function Find() {
  return (
    <div className="find-area">
      <div className="container custom-container">
        <div className="row">
          <div className="col-12">
            <form >
              <div className="find-wrap">
                <div className="location">
                  <i className="flaticon-location" />
                  <input type="text" defaultValue="Entrer Ville, État ou Code Postal" />
                </div>
                <div className="find-category">
                  <ul>
                    <li><Link to="/shop"><i className="flaticon-dog" /> Trouver Votre Chien</Link></li>
                    <li><Link to="/shop"><i className="flaticon-happy" /> Trouver Votre Chat</Link></li>
                    <li><Link to="/shop"><i className="flaticon-dove" /> Trouver Vos Oiseaux</Link></li>
                  </ul>
                </div>
                <div className="other-find">
                  <div className="dropdown">
                    <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Trouver D'autres Animaux
                    </button>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <Link className="dropdown-item" to="/shop">Trouver Votre Chien</Link>
                      <Link className="dropdown-item" to="/shop">Trouver Votre Chat</Link>
                      <Link className="dropdown-item" to="/shop">Trouver Vos Oiseaux</Link>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Find;
